import React from 'react';
import JavascriptStatements from './JavascriptStatements.jsx';
import JavascriptKeywords from './JavascriptKeywords.jsx';
import JavascriptKeywordsReserved from './JavascriptKeywordsReserved.jsx';

export default function JsStatements() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Statements</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/statements' className='underline'>JS Statements</a></li>
<li><a href='/javascript/keywords' className='underline'>JS Keywords Reference</a></li>
<li><a href='/javascript/keywords-reserved' className='underline'>JS Keywords Reserved</a></li>
      </ul>
    </div>
  );
}
